/*
 * jn-insurance.js — Shipping Insurance cart toggle.
 *
 * A checkbox in the cart drawer footer adds / removes a single "Shipping
 * Insurance" line (SKU SHIPPING-INSURANCE, one non-tracked variant). The line's
 * PRICE is set server-side by a Cart Transform function to exactly 2% of the
 * order subtotal (gross − discounts), so this script never computes money — it
 * only adds, removes, and keeps the box in sync.
 *
 * Sync model: after any mutation we dispatch `cart:refresh`, which makes
 * <cart-drawer> re-fetch its section HTML. The checkbox's checked state and the
 * displayed price are rendered server-side from whether the insurance line is in
 * the cart (see sections/cart-drawer.liquid), so the UI is always authoritative
 * after a refresh.
 */
(function () {
  if (window.__jnInsuranceInit) return;
  window.__jnInsuranceInit = true;

  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function variantId() {
    var el = document.querySelector('[data-jn-insurance]');
    if (!el) return 0;
    var v = parseInt(el.getAttribute('data-ins-variant'), 10);
    return isNaN(v) ? 0 : v;
  }

  function getCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refreshDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  function addInsurance(vid) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }),
    });
  }

  function removeInsurance(vid) {
    return getCart().then(function (cart) {
      var line = (cart.items || []).filter(function (i) { return i.variant_id === vid; })[0];
      if (!line) return null;
      return fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 }),
      });
    });
  }

  // User toggles the checkbox (event-delegated so it survives drawer re-renders).
  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest ? e.target.closest('[data-jn-insurance-toggle]') : null;
    if (!cb) return;
    var vid = variantId();
    if (!vid || busy) return;
    busy = true;
    cb.disabled = true;
    var wantChecked = cb.checked;
    Promise.resolve(wantChecked ? addInsurance(vid) : removeInsurance(vid))
      .then(function () { refreshDrawer(); })
      .catch(function () {
        cb.checked = !wantChecked; // revert on failure (no refresh happened)
        cb.disabled = false;
      })
      .then(function () { busy = false; });
  });

  // Never leave insurance as the only thing in the cart — if every other line is
  // gone, drop the insurance line too so the cart reads as empty.
  function cleanupLoneInsurance() {
    var vid = variantId();
    if (!vid || busy) return;
    getCart().then(function (cart) {
      var items = cart.items || [];
      if (!items.length) return;
      var hasIns = items.some(function (i) { return i.variant_id === vid; });
      var hasOther = items.some(function (i) { return i.variant_id !== vid; });
      if (hasIns && !hasOther) {
        busy = true;
        Promise.resolve(removeInsurance(vid))
          .then(function () { refreshDrawer(); })
          .then(function () { busy = false; });
      }
    });
  }
  document.addEventListener('cart-drawer:refreshed', cleanupLoneInsurance);
  document.addEventListener('cart:change', cleanupLoneInsurance);
})();
